import jsPsychHtmlButtonResponse from '@jspsych/plugin-html-button-response';
import audioButtonResponse from "@jspsych/plugin-audio-button-response";
import fullscreen from "@jspsych/plugin-fullscreen";
import preload from '@jspsych/plugin-preload';
import { initJsPsych } from "jspsych";

const JsPsychTaskMain = ({ onComplete, display_element, timeL, timelineVariables, setTaskStarted, timeout, panelType }) => {

  const jsPsych = initJsPsych({
    on_finish: async () => {

      const filteredData = jsPsych?.data?.get()?.filterCustom((trial) => {
        return trial?.task === 'response';
      });

      const score = ((filteredData?.trials?.filter((item) => item.is_correct == true)?.length / filteredData?.trials?.length) * 100)?.toFixed(2)

        jsPsych.run([
          {
            type: jsPsychHtmlButtonResponse,
            // stimulus: `<h1>The task has been successfully completed</h1><h1>Your Score : ${score}%</h1><p><br></p>`,
            stimulus: `<h1>The task has been successfully completed</h1>`,
            choices: ["Finish"],
            on_finish: () => {
              onComplete(filteredData);
            }
          }
        ]);
    },
    display_element,
  });

  const timeline = [...timeL];
  const audioFiles = timelineVariables?.map(item => item?.audio);
  const sendResponseToServer = async (response) => {};
  const mainAudioFiles = audioFiles?.filter(audio => audio);
  const allAudioFiles = [...mainAudioFiles];

  const preloadAudioFiles = {
    type: preload,
    auto_preload: true,
    audio: allAudioFiles,
    continue_after_error: true,
    on_load: () => console?.log('All audio files preloaded successfully.'),
    on_error: (error) => console?.log('Error preloading audio:', error),
  };

  timeline.unshift(preloadAudioFiles);

  // Shuffle ONLY items; buttons ALWAYS in fixed order (Option 1, Option 2).
  const shuffleItemsArray = (array) => {
    if (!array?.length) return array;
    return [...array].sort(() => Math.random() - 0.5);
  };
  const shuffledItems = shuffleItemsArray(timelineVariables ?? []);

  shuffledItems.forEach((item) => {
    // Buttons: ALWAYS fixed order. Do NOT shuffle options.
    const choices = item?.choices ?? [];

    const trial = {
      type: audioButtonResponse,
      stimulus: item?.audio,
      choices,
      // prompt: "<h2>What did the person say?</h2><div id='countdown'></div>",
      // prompt: "<h2>What did the person say?</h2>",
      prompt: function () {
        const currentIndex = jsPsych.data.get().filter({ task: 'response' }).count() + 1;
        const total = shuffledItems.length;
        const percent = Math.round((currentIndex / total) * 100);

        return `
         <h2 style="text-align: center; font-size: 18px; font-weight: 500; margin-top: 20px;">
            What did the person say?
          </h2>
          <div style="margin-bottom: 30px; width: 100%; max-width: 600px; margin-left: auto; margin-right: auto;">
            <div style="
              height: 10px;
              background-color: #f3e5dc;
              border-radius: 999px;
              overflow: hidden;
              box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
            ">
              <div style="
                height: 100%;
                width: ${percent}%;
                background-color:rgb(0, 0, 0);
                transition: width 0.4s ease;
              "></div>
            </div>
            <div style="margin-top: 6px; text-align: right; font-size: 13px; color: #795548; font-weight: 500;">
              ${percent}% completed
            </div>
          </div>
      
         
        `;
      },
      trial_duration: timeout,
      post_trial_gap: 500,
      data: {
        task: 'response',
        id: item?.id,
        courseId: item?.courseId,
        taskId: item?.taskId,
        original_choices: choices,
        options: choices,
        correct_answer: choices[parseInt(item?.answer, 10)],
      },
      on_load: () => {
        const timeInMillis = typeof timeout === 'number' && !isNaN(timeout) ? timeout : 15000;
        const countdownElement = document.querySelector("#countdown");
        let timeLeft = timeInMillis / 1000;

        if (countdownElement) {
          countdownElement.innerHTML = `Time left: ${timeLeft}s`;

          const countdownInterval = setInterval(() => {
            timeLeft -= 1;
            if (timeLeft >= 0) {
              countdownElement.innerHTML = `Time left: ${timeLeft}s`;
            } else {
              clearInterval(countdownInterval);
            }
          }, 1000);
        }
      },
      on_finish: (data) => {
        const participant_response_index = data?.response;
        const responseTime = data.rt;
        // Buttons in fixed order: response index = original option index.
        const originalIndex = participant_response_index;
        if (participant_response_index !== null && participant_response_index !== undefined) {
          data.participant_answer = data.original_choices?.[participant_response_index] || "Too Slow";
          data.is_correct = data.participant_answer === data.correct_answer;
          setTaskStarted(true);
          sendResponseToServer({
            courseId: data?.courseId,
            taskId: data?.taskId,
            questionId: data?.id,
            answer: originalIndex.toString(),
            options: data?.options,
            responseTime: responseTime || timeout
          });
        } else {
          data.participant_answer = "Too Slow";
          data.is_correct = false;
        }
      },
    };

    const feedbackTrial = {
      type: jsPsychHtmlButtonResponse,
      stimulus: function () {
        const lastTrial = jsPsych.data.get().last(1).values()[0];
        if (lastTrial.participant_answer === "Too Slow") {  return "<h1>Too Slow</h1>"; }
        return `<h1>${lastTrial.is_correct ? "Correct!" : "Incorrect!"}</h1>`;
      },
      choices: [],
      trial_duration: 1500,
    };

    timeline.push(trial, feedbackTrial);
  });

  timeline.push({
    type: fullscreen,
    fullscreen_mode: false,
    on_finish: () => {
      setTaskStarted(false);
    },
  });

  jsPsych.run(timeline);
};

export default JsPsychTaskMain;